import { render } from "./TermsV20250611.vue?vue&type=template&id=51ad4b06&scoped=true"
const script = {}

import "./TermsV20250611.vue?vue&type=style&index=0&id=51ad4b06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ad4b06"]])

export default __exports__